export const removeNullAndUndefined = (obj: Record<string, any>) => {
	const newObject = { ...obj };

	Object.keys(newObject).forEach((key) => {
		if (newObject[key] === null || newObject[key] === undefined) {
			delete newObject[key];
		}
	});

	return newObject;
};
